import {
  Component,
  EventEmitter,
  Injector,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges
} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {ParentModule} from 'app/pages/A2-utils/ParentClass/parent-module';
import {constant} from '../../../app.constants';
import {ReservationService} from '../reservations.service';
import {Subscription} from 'rxjs/Subscription';
import {resetServiceEnabled, verifyServiceEnabled} from '../../A2-utils/export-functions/functions-services';
import {EnumStatusTrip} from '../../../core/interfaces/change-status.interface';
import {ToastrAlertHelper} from 'app/core/helpers/toastr-alert-helper-service';
import {SweetAlertHelper} from 'app/core/helpers/sweet-alert-helper.service';

@Component({
  selector: 'app-trip-status-change',
  templateUrl: './trip-status-change.component.html',
  styleUrls: ['./trip-status-change.component.scss']
})
export class TripStatusChangeComponent extends ParentModule implements OnInit, OnChanges, OnDestroy {
  @Input() statusId = 0;
  @Input() companyId = 0;
  @Input() tripId = 0;
  @Input() actualPickup = '';
  @Input() actualDropoff = '';
  @Input() cancelReasonId = 0;
  @Input() leg: string;
  @Input() numberOfLegs = 0;
  @Input() permissions = {};
  @Output() response = new EventEmitter < any > ();
  @Input() isStandingOrder: boolean;

  private observables: Subscription[] = [];
  public tripStatus = EnumStatusTrip;
  public tripStatusForm: FormGroup;
  private selectedStatus: number;
  private deleteAllLegs = false;
  public cancelReasons: any[];
  public timeMask = constant.MASK_TIME;
  public disableButton = false;
  public showLoading = false;

  showNotes = false;
  allowStatus = [];

  constructor(
    protected service: ReservationService,
    protected fb: FormBuilder,
    protected Inject: Injector,
    private toastrAlertHelper: ToastrAlertHelper,
    private sweetAlertHelper: SweetAlertHelper,
  ) {
    super('app-trip-status-change', Inject);
  }

  ngOnInit() {
    this.createForm();
    this.getAllCAncelReasons();
    this.observables.push(
    this.actions
    .subscribe(success => {
      const status = [];
      try {
        if (Array.isArray(success.actionsArray)) {
          success.actionsArray.forEach((element: any) => {
            const act = element.actionname.split(':');
            if (act.length === 3 && act[0] === 'StatusTrip') {
              status.push(parseInt(act[2], 10));
            }
          });
        }
        this.allowStatus = status;
      } catch (error) {
      }
    }, error => {
    }));
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['statusId'] || changes['cancelReasonId'] || changes['actualPickup'] || changes['actualDropoff']) {
      if (this.tripStatusForm) {
        this.tripStatusForm.patchValue({
          tripstatusid: this.statusId,
          tripcancelreasonid: this.cancelReasonId,
          actualpickup: this.actualPickup,
          actualdropoff: this.actualDropoff,
          note: ''
        });
      }
    }
  }

  private createForm() {
    this.tripStatusForm = this.fb.group({
      tripstatusid: this.statusId,
      tripcancelreasonid: this.cancelReasonId,
      actualpickup: this.actualPickup,
      actualdropoff: this.actualDropoff,
      note: ''
    });
    this.observables.push(this.tripStatusForm.get('tripstatusid').valueChanges.subscribe(
      (value) => {
        this.validStatus(value);
      }
    ));
  }

  /**
   * get all cancel reasons
   */
  private getAllCAncelReasons() {
    this.observables.push(
    this.service.getCancelReason().subscribe(
      data => this.cancelReasons = data
    ));
  }

  private validStatus(value: EnumStatusTrip): void {
    this.selectedStatus = value;
    this.showNotes = false;

    this.requiredControl('note', false);
    if (this.tripStatusForm.get('note').value) {
      this.tripStatusForm.get('note').setValue('');
    }
    this.requiredControl('tripcancelreasonid', false);
    if (this.tripStatusForm.get('tripcancelreasonid').value) {
      this.tripStatusForm.get('note').setValue('');
    }

    switch (value) {
      case EnumStatusTrip.Cancelled:
        this.requiredControl('tripcancelreasonid', true);
        this.requiredControl('note', true);
        this.showNotes = this.statusId !== EnumStatusTrip.Cancelled;
        break;
      case EnumStatusTrip.NoShow:
        this.requiredControl('note', true);
        this.messageNoShow();
        this.showNotes = this.statusId !== EnumStatusTrip.NoShow;
        break;
    }
  }
  /**
   * @name messageNoShow
   * @description presenta mensaje cuando es NoShow
   */
  messageNoShow() {
    return this.sweetAlertHelper.createCustomAlert({
      type: 'warning',
      title: 'NoShow',
      text: 'Please contact the client to make them aware of no show',
      allowOutsideClick: false
    });
  }
  /**
   * @description: mensaje para cancelar otros leg si no show
   */
  private messageCancelLegforNoShow(calback?: () => void) {
    if (this.leg === 'A' && this.numberOfLegs > 1) {
      this.sweetAlertHelper.createCustomAlert({
        title: 'Question',
        text: 'Do you want to cancel the other Legs for this reservation?',
        type: 'question',
        showCancelButton: true,
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        cancelButtonColor: '#d33',
        allowOutsideClick: false
      })
        .then(
          (result) => {
            if (result.value) {this.deleteAllLegs = true; }
            calback();
          }
        );
    } else {
      calback();
    }
  }

  /**
   * @description: save company action
   */
  save() {
    const changeStatus = () => {
      this.disableButton = true;
      this.showLoading = true;
      const data = {
        tripid: this.tripId,
        oldvalue: this.statusId,
        newvalue: this.selectedStatus,
        auxvalue: this.selectedStatus === 7 ? this.tripStatusForm.value.tripcancelreasonid : null,
        actualpickup: this.selectedStatus === 5 ? this.tripStatusForm.value.actualpickup : null,
        actualdropoff: this.selectedStatus === 10 ? this.tripStatusForm.value.actualdropoff : null,
        note: this.showNotes ? this.tripStatusForm.value.note : null,
        alllegs: this.deleteAllLegs
      };
      if (verifyServiceEnabled('reservationEditStatusTrip')) {
      this.observables.push(
        this.service.editStatus(data).subscribe(
          response => {
            this.deleteAllLegs = false;
            this.showLoading = false;
            const ed = response;
            ed.newValue = this.selectedStatus;
            ed.cancelReason = this.selectedStatus === 7 ? this.tripStatusForm.value.tripcancelreasonid : null;
            this.response.emit(ed);
            resetServiceEnabled('reservationEditStatusTrip');
            this.toastrAlertHelper.info('Wait, Updating Status...');
          },
          err => {
            if (err.hasOwnProperty('message') && !isNaN(err.message)) {
              this.sweetAlertHelper.createCustomAlert({
                text: 'The status of this leg changed, please reload ...',
                type: 'info',
              });
              this.showLoading = false;
              return;
            } else {
              this.response.emit(err);
              this.deleteAllLegs = false;
              this.disableButton = false;
            }
            this.showLoading = false;
            resetServiceEnabled('reservationEditStatusTrip');
          }
        ));
    }
    };
    if (this.selectedStatus === 7 && this.leg === 'A' && this.numberOfLegs > 1) {
      this.sweetAlertHelper.createCustomAlert({
        title: 'Question',
        text: 'Do you want to cancel the other Legs for this reservation?',
        type: 'question',
        showCancelButton: true,
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        cancelButtonColor: '#d33',
        allowOutsideClick: false
      }).then(res => {
        this.deleteAllLegs = !!res.value;
        this.sweetAlertHelper.createCustomAlert({
          title: 'Cancel Trip',
          text: 'Are you sure you want to cancel this Reservation/Trip?',
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Yes',
          cancelButtonText: 'No',
          cancelButtonColor: '#d33',
          allowOutsideClick: false
        }).then(respon => {
          if (!respon.value) {
            this.deleteAllLegs = false;
          } else {
            changeStatus();
          }
        });
      });
    } else if (this.selectedStatus === 6) {
      this.messageCancelLegforNoShow(changeStatus);
    } else {
      changeStatus();
    }
  }
  /**
   * @description valida campo del form con value
   * @param control
   * @param value
   */
  public formValueVadid(control: string, value: any): boolean {
    return this.tripStatusForm.get(control).value === value;
  }
  public onResponseCompleteStatus(event) {
    if (event.success) {
      this.sweetAlertHelper.createCustomAlert({
        title: 'Complete Trip',
        text: event.message,
        type: 'success',
      });
      const ed = event;
      ed.newValue = this.selectedStatus;
      ed.cancelReason = null;
      this.response.emit(ed);
    } else {
      this.sweetAlertHelper.createCustomAlert({
        title: 'Complete Trip',
        text: event.message,
        type: 'error',
      });
      this.response.emit(event);
    }
  }
  requiredControl(key: string, required: boolean): void {
    this.tripStatusForm.get(key).setValidators(required ? [Validators.required] : null);
    this.tripStatusForm.get(key).updateValueAndValidity();
  }
  public disabledButton(): boolean {
    let value = true;
    if ( this.tripStatusForm.valid &&
      this.statusId !==  this.tripStatusForm.get('tripstatusid').value &&
      !this.disableButton
    ) {
      value = false;
    }
    return value;
  }

  ngOnDestroy(): void {
    this.observables.forEach(item => item.unsubscribe());
  }


  get showActualPickupTime(): boolean {
    return this.tripStatusForm.get('tripstatusid').value === 5 && !this.actualPickup;
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/trip-reservations/trip-status-change/trip-status-change.component.ts